import { Container, Typography } from "@mui/material";

import { useListPublicPoliciesQuery } from "api/public/policies/policies.api";
import { PolicyLetter } from "api/public/policies/policies.types";
import NiapAccordion from "components/MUI/Accordion/NiapAccordion";
import Subheader from "components/Subheader";
import { usePageTitle } from "hooks/usePageTitle";

import PolicyLettersTable from "./components/PolicyLettersTable";

const EMPTY_POLICIES: PolicyLetter[] = [];

export default function PoliciesPage() {
  const { data: activePolicies = EMPTY_POLICIES, isLoading: loadingActive } =
    useListPublicPoliciesQuery({
      archived: false,
    });

  const {
    data: inactivePolicies = EMPTY_POLICIES,
    isLoading: loadingInactive,
  } = useListPublicPoliciesQuery({
    archived: true,
  });

  usePageTitle("NIAP - Policies");

  return (
    <>
      <Subheader pageName={"Policies"} />

      <Container maxWidth="lg" sx={{ mt: 3 }}>
        <Typography variant="h3" fontWeight="bold" pb={3}>
          RESOURCES - SCHEME POLICY LETTERS
        </Typography>

        <Typography mb={3}>
          The following CCEVS guidance documents are currently available.
          Comments on any scheme publication can be forwarded to
          niap@niap-ccevs.org.
        </Typography>

        <NiapAccordion
          title={`${activePolicies.length} CURRENT POLICY LETTERS`}
        >
          <PolicyLettersTable
            archived={false}
            policies={activePolicies}
            loading={loadingActive}
          />
        </NiapAccordion>

        <NiapAccordion
          title={`${inactivePolicies.length} SUPERSEDED OR OUTDATED POLICY LETTERS`}
        >
          <PolicyLettersTable
            archived={true}
            policies={inactivePolicies}
            loading={loadingInactive}
          />
        </NiapAccordion>
      </Container>
    </>
  );
}
